import { getAccessorParts } from './parse-accessor.js';

/**
 * Gets value from accessor.
 *
 * @param record -
 * @param accessor -
 * @returns Type of the value
 * @internal
 */
export function accessValue<T>(
  record: Record<string, unknown>,
  accessor: string,
): T | undefined {
  const accessorParts = getAccessorParts(accessor);
  let value = record;

  for (let i = 0; i < accessorParts.length; i++) {
    const part = accessorParts[i];
    value = value?.[part] as Record<string, unknown>;

    if (value === undefined) {
      return undefined;
    }
  }

  return value as T;
}
